const ARTICLES_NON_BUDGETAIRE_OPTIONS = [
	{
		'data-testid': 'articleNonBudgetaire1632',
		dateCaduque: null,
		key: 1632,
		text: 'Opération sur capital remboursable in fine (compte 1632)',
		value: '1632',
	},
	{
		'data-testid': 'articleNonBudgetaire4091',
		dateCaduque: null,
		key: 4091,
		text: 'Fournisseurs – Avances versées sur commande (compte 4091)',
		value: '4091',
	},
	{
		'data-testid': 'articleNonBudgetaire4093',
		dateCaduque: null,
		key: 4093,
		text: 'Mandat – Avance de fonds ou remboursement de débours (compte 4093)',
		value: '4093',
	},
	{
		'data-testid': 'articleNonBudgetaire4648',
		dateCaduque: null,
		key: 4648,
		text: 'Autres encaissements pour le compte de tiers (compte 4648)',
		value: '4648',
	},
	{
		'data-testid': 'articleNonBudgetaire465',
		dateCaduque: null,
		key: 465,
		text: 'Avances en garantie d’emprunt (compte 465)',
		value: '465',
	},
	{
		'data-testid': 'articleNonBudgetaire506',
		dateCaduque: null,
		key: 506,
		text: 'Obligations (compte 506)',
		value: '506',
	},
	{
		'data-testid': 'articleNonBudgetaire507',
		dateCaduque: null,
		key: 507,
		text: 'Bons du Trésor (compte 507)',
		value: '507',
	},
	{
		'data-testid': 'articleNonBudgetaire508',
		dateCaduque: null,
		key: 508,
		text: 'Autres valeurs mobilières et créances assimilées (compte 508)',
		value: '508',
	},
	{
		'data-testid': 'articleNonBudgetaire5428',
		dateCaduque: null,
		key: 5428,
		text: 'Disponibilités chez d’autres tiers (compte 5428)',
		value: '5428',
	},
];

export default ARTICLES_NON_BUDGETAIRE_OPTIONS;
